import React, { useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const NewReservationModal = ({ onClose, onCreate, defaultCompanyName, timeSlots }) => {
    const [formData, setFormData] = useState({
        customer: {
            firstName: '',
            lastName: '',
            email: '',
            phoneNumber: '',
        },
        companyName: defaultCompanyName || '',  // Bedrijfsnaam uit props
        reservationDate: '',
        reservationTime: '',
        numberOfGuests: '',
        specialRequests: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name.startsWith('customer.')) {
            const key = name.split('.')[1];
            setFormData(prevState => ({
                ...prevState,
                customer: {
                    ...prevState.customer,
                    [key]: value
                }
            }));
        } else {
            setFormData(prevState => ({
                ...prevState,
                [name]: value
            }));
        }
    };

    const handleTimeSlotChange = (e) => {
        const { value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            reservationTime: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onCreate(formData);  // Verzenden van gegevens
    };

    const formatTime = (time) => {
        const [hours, minutes] = time.split(':');
        return `${hours.padStart(2, '0')}:${minutes.padStart(2, '0')}`;
    };

    return (
        <div className="modal show fade" style={{ display: 'block' }}>
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Nieuwe Reservering</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                                <label className="form-label">Voornaam</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="customer.firstName"
                                    value={formData.customer.firstName}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Achternaam</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="customer.lastName"
                                    value={formData.customer.lastName}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Email</label>
                                <input
                                    type="email"
                                    className="form-control"
                                    name="customer.email"
                                    value={formData.customer.email}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Telefoonnummer</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="customer.phoneNumber"
                                    value={formData.customer.phoneNumber}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Bedrijfsnaam</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    name="companyName"
                                    value={formData.companyName}
                                    onChange={handleChange}
                                    disabled  // Bedrijfsnaam niet aanpasbaar
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Datum</label>
                                <input
                                    type="date"
                                    className="form-control"
                                    name="reservationDate"
                                    value={formData.reservationDate}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Tijd</label>
                                <select
                                    className="form-select"
                                    name="reservationTime"
                                    value={formData.reservationTime}
                                    onChange={handleTimeSlotChange}
                                    required
                                >
                                    <option value="" disabled>Selecteer een tijdslot</option>
                                    {timeSlots.map((slot, index) => (
                                        <option key={index} value={slot.startTime}>
                                            {formatTime(slot.startTime)}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Aantal Personen</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    name="numberOfGuests"
                                    value={formData.numberOfGuests}
                                    onChange={handleChange}
                                    required
                                />
                            </div>
                            <div className="mb-3">
                                <label className="form-label">Speciale Verzoeken</label>
                                <textarea
                                    className="form-control"
                                    name="specialRequests"
                                    value={formData.specialRequests}
                                    onChange={handleChange}
                                />
                            </div>
                            <div className="modal-footer d-flex justify-content-between">
                                <buttonn style={{marginLeft: '-10px'}} type="submit" className="btn btn-primary" onClick={handleSubmit}>Toevoegen</buttonn>
                                <button style={{marginRight: '-10px'}} type="button" className="btn btn-secondary" onClick={onClose}>Annuleren</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default NewReservationModal;
